"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PortfolioIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.83 17h6.34a3.001 3.001 0 1 1 0 2H8.83a3.001 3.001 0 1 1 0-2M3 5c0-1.105.895-2 1.994-2h12.012C18.107 3 19 3.888 19 5c0 1.105-.895 2-1.994 2H4.994A1.99 1.99 0 0 1 3 5m5 6a2 2 0 0 1 2.003-2h8.994a2 2 0 1 1 0 4h-8.994A1.996 1.996 0 0 1 8 11"/></svg>`
}, props));
PortfolioIcon.displayName = 'PortfolioIcon';
var _default = exports.default = PortfolioIcon;